import facebookBox from '@lumapps/assets/brands/facebook-box.svg';
import linkedin from '@lumapps/assets/brands/linkedin.svg';
import twitterBox from '@lumapps/assets/brands/twitter-box.svg';
import email from '@lumapps/assets/common/email.svg';
import googleCurrents from '@lumapps/assets/google-apps/google_icon_currents.svg';

import { WIDGET_SHARE } from './keys';

export const WIDGET_SHARE_TYPE = 'share';

export const SHARE_TARGETS = {
    email: {
        linkPrefix: 'mailto:?body=',
        tooltipKey: WIDGET_SHARE.SHARE_ON_EMAIL,
        image: email,
    },

    facebook: {
        linkPrefix: 'https://www.facebook.com/sharer/sharer.php?u=',
        tooltipKey: WIDGET_SHARE.SHARE_FACEBOOK_BTN_TITLE,
        image: facebookBox,
    },

    'google-currents': {
        linkPrefix: 'https://currents.google.com/share?url=',
        tooltipKey: WIDGET_SHARE.SHARE_ON_GOOGLE_CURRENTS,
        image: googleCurrents,
    },

    linkedin: {
        linkPrefix: 'https://www.linkedin.com/shareArticle?mini=true&url=',
        tooltipKey: WIDGET_SHARE.SHARE_MODAL_LINKEDIN,
        image: linkedin,
    },

    twitter: {
        linkPrefix: 'https://twitter.com/home?status=',
        tooltipKey: WIDGET_SHARE.SHARE_MODAL_TWITTER,
        image: twitterBox,
    },
} as const;
